import styles from "./CreateAccount.module.css"
import Navbar from "../../components/Navbar/NavbarOnboarding/Navbar";
import CreateAccountForm from "./components/form/CreateAccountForm";
import { useTranslation } from "react-i18next";
/**
* Create account page.
* Contains form for creating account.
* @returns TSX.Element
*/
const CreateAccountPage = () => {
    return(
        <>
            <Navbar/>
            <div className={styles.Page}>
                <div className={styles.CreateAccountBlock}>
                    <CreateAccountForm/>
                </div>
            </div>
        </>
    )
};

export default CreateAccountPage;
